import { render, staticRenderFns } from "./dbs__form.vue?vue&type=template&id=939d928a"
import script from "./dbs__form.vue?vue&type=script&lang=js"
export * from "./dbs__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports